module.exports = __webpack_public_path__ + "static/media/ame.9062d6bf.png";